export const SET_STORE = "SET_STORE";
export const SET_STORES = "SET_STORES";
export const ADD_STORE = "ADD_STORE";
export const UPDATE_STORE = "UPDATE_STORE";
export const DELETE_STORE = "DELETE_STORE";
